module.exports = __webpack_public_path__ + "img/loans-selected.812022f9.svg";